import {observable, action, runInAction, computed} from 'mobx'
import { message } from 'antd'
import uuid from 'uuid/v4'
import {get, json} from '../../../../utils/ajax'
import { isAuthenticated } from '../../../../utils/Session'
import {setStore, ValueObjToObj} from "../../../../utils/Utils";
import faultCaseContentMaintenanceStore from './store'

class faultStore {
    @observable contents   //内容维护数据
    @observable editingKey   //故障引导中点击当前行key
    @observable listId   //点击list行 保存行id
    @observable contentLoading   //内容维护加载loading

    constructor () {
        this.contents=[]
        this.editingKey = '';
        this.listId=''
        this.contentLoading=true
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }


    //点击当前行，保存list行Id
    @action
    saveListId=(id)=>{
        this.listId=id
        this.getEditContent()
    }


    /**
     * 获取到每个小节内容和ID
     */
    @action changeContentTitle = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (id === item.id) {
                    return {...item, title: value}
                }
                return item
            })
        })
    }

    /**
     * 获取到每个编辑器的内容和ID
     */
    @action setContent = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, defaultContent: value}
                }
                return item
            })
        })
    }

    /**
     * 删除编辑框里的图片
     */
    @action delImage = (contentId, imageIndex) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === contentId) {
                    return {...item, image: item.image.trim().split(',').filter((img, index) => index !== imageIndex).join(',')}
                }
                return item
            })
        })
    }


    /**
     * 添加小节
     */
    @action addContent = (id, type) => {
        const contents = []
        this.contents.forEach(item => {
            contents.push(item)
            if (item.id === id) {
                if(type==='3'){
                    let data = {
                        id: uuid(),
                        step: 1,
                        stepTitle: '',
                        stepDescription: '',
                        is: '',
                        yesJumpDescription: '',
                        no: '',
                        noJumpDescription: '',
                        imageUrl: '',
                        contentId:uuid(),
                        contentTitleId:this.listId,
                    }
                    this.editingKey = data.id
                    let faultCaseContentGuidedDiagnosisList = []
                    faultCaseContentGuidedDiagnosisList.push(data)
                    contents.push({
                        id: data.contentId,
                        image: '',
                        faultCaseContentGuidedDiagnosisList: faultCaseContentGuidedDiagnosisList,
                        exist:false,
                        type: type * 1,
                        contentTitleId:this.listId,
                        defaultContent:'',
                        sort: this.contents.length,
                    })
                }
                else{
                    contents.push({
                        id: `${uuid()}`,
                        image: '',
                        defaultContent: '',
                        type: type * 1,
                        contentTitleId:this.listId,
                        sort: this.contents.length
                    })
                }
            }
        })
        runInAction(() => {
            this.contents = contents
        })
    }


    /**
     * 删除编辑框里的内容
     */
    @action delContent =async (id) => {
        const contents = this.contents.filter(item => item.id !== id)
        runInAction(() => {
            this.contents = contents.length > 0 ? contents : [{
                id: `${uuid()}`,
                image: '',
                defaultContent: '',
                type: 1,
            }]
        })
    }


    /**
     * 添加图片
     */
    @action addImage = (id, url) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, image: item.image.trim().length > 0 ? `${item.image},${url}` : url}
                }
                return item
            })
        })
    }

    /**
     * 获取ID 用于上移编辑框
     */
    @action contentUp = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if (index > 0) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index - 1)
            })
        }
        this.contents.map((item,index)=>{
            item.sort=index
            return {...item}
        })
    }

    /**
     * 获取ID 用于下移编辑框
     */
    @action contentDown = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if(index+1 === this.contents.length){
            return
        }
        if (index >= 0 && index < this.contents.length) {
            this.contents = this.swapItems(this.contents, index, index + 1)
        }
        this.contents.map((item,index)=>{
             item.sort=index
            return {...item}
        })
    }

    swapItems = (arr, index1, index2) => {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
    }


    /***
     * 点击 新增步骤添加单条故障诊断
     * @param row
     */
    @action
    rowSave =async (contentId) => {
        const data =  [...this.contents]
        const newData = data.filter(ele=>{
            if(ele.id === contentId){
                return ele
            }
        });
        const step = newData[0].faultCaseContentGuidedDiagnosisList.length
        newData.forEach(item=>{
            let data = {
                contentId:contentId,
                contentTitleId:this.listId,
                id: uuid(),
                step: step+1,
                stepTitle: '',
                stepDescription: '',
                is: '',
                yesJumpDescription: '',
                no: '',
                noJumpDescription: '',
                imageUrl: '',
            }
            item.faultCaseContentGuidedDiagnosisList.push({...data});
            this.editingKey = ''
        })
        this.contents = data
    }


    /**
     * 故障引导删除行
     * @param id
     */
    @action
    handleDeleteRow = async(id,contentId) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentGuidedDiagnosis/delById/id/${id}`)
        if (res.status) {
            runInAction(() => {
                const dataSource = [...this.contents];
                const newData = dataSource.filter(ele=>{
                    if(ele.id === contentId){
                        return ele
                    }
                });
                newData.forEach((item,index)=>{
                    item.faultCaseContentGuidedDiagnosisList = item.faultCaseContentGuidedDiagnosisList.filter( i => i.id !== id )
                    // item.faultCaseContentGuidedDiagnosisList.for
                })
                newData[0].faultCaseContentGuidedDiagnosisList.forEach((item,index)=>{
                    item.step=index+1
                })
                this.contents = dataSource
                message.success(res.data)
            })
        }
    }


    //行内点击添加步骤,需要添加至当前行的下一行
    @action
    addRowPlus = (row) => {
            const data =  [...this.contents]
            const newData = data.filter(ele=>{
                if(ele.id === row.contentId){
                    return ele
                }
            });
            newData.forEach(item=>{
                let data = {
                    contentId:row.contentId,
                    contentTitleId:this.listId,
                    id: uuid(),
                    step: row.step,
                    stepTitle: '',
                    stepDescription: '',
                    is: '',
                    yesJumpDescription: '',
                    no: '',
                    noJumpDescription: '',
                    imageUrl: '',
                }
                item.faultCaseContentGuidedDiagnosisList.splice(row.step,0,data)
                this.editingKey = ''
            })
            newData.forEach((item,)=>{
                item.faultCaseContentGuidedDiagnosisList.forEach((i,index)=>{
                    i.step = index +1
                })
            })
                this.contents = data
            }


    //上传图片时存储当前行信息
    @action
    saveRecordRow=(record)=>{
        this.imgUrlRecord=record
    }

    //单条故障诊断图片保存
    @action
    faultAddImage = (url) => {
       this.imgUrl = url
        let obj ={}
        if(this.imgUrlRecord.imageUrl.length===1){
            obj['imageUrl'] = this.imgUrlRecord.imageUrl.concat(url)
        }else if(this.imgUrlRecord.imageUrl.length===2){
            let arr =this.imgUrlRecord.imageUrl
            let newArr = arr.slice(0);
            newArr.splice(0, 1);
            newArr.concat(url)
            obj['imageUrl'] = newArr.concat(url)
        }else{
            obj['imageUrl'] = [url]
        }
        this.handleSaveRow({ ...this.imgUrlRecord,...obj});
    }

    //删除图片功能
    @action
    faultdelImage=(arr)=>{
        this.imgUrlRecord=arr
        let obj ={}
        obj['imageUrl']=[]
        this.handleSaveRow({ ...this.imgUrlRecord,...obj});
    }

    //--------------------------------------修改内容---------------------
    //获取内容
    @action
    getEditContent =async() =>{
        this.contentLoading=true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContent/queryTheContentBasedOnTheContentTitleId/${this.listId}`)
        runInAction(()=>{
            // let obj = {
            //     id :uuid(),
            //     defaultContent:'',
            //     image: "",
            //     title: '',
            //     type:  2,
            //     contentTitleId:this.listId,
            //     sort: this.contents.length
            // }

            let data = {
                id: uuid(),
                step: 1,
                stepTitle: '',
                stepDescription: '',
                is: '',
                yesJumpDescription: '',
                no: '',
                noJumpDescription: '',
                imageUrl: '',
                contentId:uuid(),
                contentTitleId:this.listId,
            }
            this.editingKey = data.id
            let faultCaseContentGuidedDiagnosisList = []
            faultCaseContentGuidedDiagnosisList.push(data)
            let arr = []
            arr.push({
                id: data.contentId,
                image: '',
                faultCaseContentGuidedDiagnosisList: faultCaseContentGuidedDiagnosisList,
                exist:false,
                type: 3,
                contentTitleId:this.listId,
                defaultContent:'',
                sort: this.contents.length,
            })
            if(res.length ===0){
                this.contents = arr
            }else{
               const content = res.map(item=>{
                   if(item.faultCaseContentGuidedDiagnosisList && item.faultCaseContentGuidedDiagnosisList.length>0){
                        item.exist=true
                    }
                   return item
                })
               this.contents = content
            }
            this.contentLoading=false
        })
    }


    /**
     * 新增修改,内容保存
     */
    @action saveContents = async () => {
        if(this.contents.length === 0){
            message.warning('请选择内容！')
            return
        }
        for (let i = 0; i < this.contents.length; i++) {
            let content = this.contents[i]
            if ((content.type===1 ||content.type===2) && !content.defaultContent.trim() && !content.image.trim()) {
                message.error('请填写完内容后保存！')
                return
            }
            if (content.type === 3 && !content.exist) {
                message.error('请保存故障引导！')
                return
            }
        }
        const dataSource = JSON.parse(JSON.stringify(this.contents))  //数据深拷贝，不改变原本数据属性
        const newData =  dataSource.map(item=>{
             if(item.type === 3){
                 item.faultCaseContentGuidedDiagnosisList=[]
             }
             return item
            })
       const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContent/addContent`,newData)
            runInAction(() => {
                if(res.status){
                    message.success(res.data)
                    this.getEditContent()
                    faultCaseContentMaintenanceStore.initListPage()

                }
            })
    }


    /***
     * 批量保存数据处理
     * @param row
     */
    @action
    handleSaveRow = (row) => {
        // console.log(JSON.parse(JSON.stringify(row)))
        const newData = [...this.contents]
        const index = newData.length >0 && newData.findIndex(item => item.id === row.contentId);
        if(index > -1){
            // console.log('存在')
            const index1 =newData[index].faultCaseContentGuidedDiagnosisList.findIndex(item => item.id === row.id);
            const item = newData[index].faultCaseContentGuidedDiagnosisList[index1]
            newData[index].faultCaseContentGuidedDiagnosisList.splice(index1, 1, {
                ...item,
                ...row,
            });
            this.contents = newData
        } else{
            console.log('new')
        }
    }

    //批量保存按钮   先删除当前小节内数据，再重新批量保存
    @action
    handSaveManyRow=async(contentId)=>{
        const data = this.contents.filter(item=> item.id===contentId)
        const arr = data[0].faultCaseContentGuidedDiagnosisList
        arr.forEach(item=>{
            item.id=uuid()
            item.imageUrl = item.imageUrl.toString()
        })
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentGuidedDiagnosis/batchDeletion?contentId=${contentId}&contentTitleId=${this.listId}`)
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentGuidedDiagnosis/addBootDiagnosticsInBatches`, arr)
        if (res.status) {
            runInAction(() => {
                message.success(res.data)
                this.contents.map(item => {
                    if (item.id === contentId) {
                        item.exist = true
                    }
                })
            })
        }
       // const arg = arr.findIndex(item=> !item.stepTitle)
       //  if (arg === -1) {
       //      arr.forEach(item=>{
       //          item.id=uuid()
       //          item.imageUrl = item.imageUrl.toString()
       //      })
       //      await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentGuidedDiagnosis/batchDeletion?contentId=${contentId}&contentTitleId=${this.listId}`)
       //      const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseContentGuidedDiagnosis/addBootDiagnosticsInBatches`, arr)
       //      if (res.status) {
       //          runInAction(() => {
       //              message.success(res.data)
       //              this.contents.map(item => {
       //                  if (item.id === contentId) {
       //                      item.exist = true
       //                  }
       //              })
       //          })
       //      }
       //  } else {
       //      message.warning('请填写步骤标题相关信息')
       //  }
    }

//    批量修改
    @action
    saveManyEdit=(contentId)=>{
        this.contents.map(item=>{
            if(item.id===contentId){
                item.exist=false
                item.faultCaseContentGuidedDiagnosisList.map(i=>{
                    if((typeof i.imageUrl === "string") && (i.imageUrl) ){
                        let arr = i.imageUrl.split(',')
                        let newArr = arr.filter(item => item && item.trim())
                        i.imageUrl = newArr
                    }
                })
            }
        })
    }


}
export default new faultStore()



// WEBPACK FOOTER //
// ./src/Backend/dongfeng/FaultDiagnosis/FaultCaseContentMaintenance/faultStore.js